import Vue from 'vue'
import App from './AppScoresNCAAF.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
